export default __webpack_public_path__ + "static/media/spectacles.1974e93f.jpg";